Apt.fn.make('call', {
	/**
	 * Initialize module
	 *
	 * @param {Object} options
	 * @returns {Object}
	 */
	init(options) {
		const scope = this;
		const priv = scope.$private;

		priv.conf = Object.assign({
			el: '$profilePhone',
			context: {}
		}, options);

		priv.uid = LS.util.uid();

		priv.bind();

		return scope;
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		LS.util.reset(this.$private.uid);
	}
}, {
	/**
	 * Bind call events
	 */
	bind() {
		const scope = this;
		const conf = scope.conf;

		$(conf.el).on('click', (e, el) => {
			const card = $(el).closest('[data-user-id]');

			let id;

			if (card.length) {
				id = card.data('user-id');
			}

			LS.api.post(conf.target + 's/' + conf.id + '/call', {
				auth: true,
				namespace: scope.uid,
				flash: false,
				data: {
					phone: el.textContent,
					recipient_id: id,
					uid: LS.user.uid(),
					url: location.pathname
				},
				success: () => {
					const event = {
						action: 'click',
						target: conf.target,
						id: conf.id,
						category: 'phone'
					};

					const type = el.dataset.type;

					if (type) {
						event.segment = type;
					}

					if (id) {
						event.attributes = {
							id: id
						};
					}

					LS.analytics.track(event, conf.context);
				}
			});
		}, {
			namespace: scope.uid
		});
	}
});